import React, { createContext, useState } from "react";
import { wait } from "../utils/genericUtils";

const LoaderContext = createContext();

function LoaderProvider({ children }) {
  const [show, setShow] = useState(false);

  const showloader = () => {
    setShow(true);
  };

  const hideloader = () => {
    wait(250, () => {
      setShow(false);
    });
  };

  return <LoaderContext.Provider value={{ show, showloader, hideloader }}>{children}</LoaderContext.Provider>;
}

export { LoaderContext, LoaderProvider };
